import script from "./LoginRepository.vue?vue&type=script&lang=js"
export * from "./LoginRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__